import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Murphy's Giving Market Newsletter Page
const NewsletterPage = () => {
  const newsletters = [
    {
      title: "Summer 2026",
      url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/2d747d00cafc4a4e_Summer%202026%20newsletter.pdf",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/4c4cee9480dd9d3e_newsletter.png"
    },
    {
      title: "April & May 2026",
      url: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/frwl697v_April%20%26%20May%202026%20newsletter.pdf",
      image: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/2uf40zkb_Screenshot%202026-06-15%20143656.jpg"
    },
    {
      title: "January - March 2026",
      url: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/oz09h64t_March%202026%20newsletter.pdf",
      image: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/naw73tlt_March%202026%20preview.png"
    },
    {
      title: "2025 Year in Review",
      url: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/ud5qdlew_2025%20Year%20in%20Review.pdf",
      image: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/apkdjnbk_Year%20in%20review%20preview.png"
    },
    {
      title: "Fall 2025 Newsletter",
      url: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/2tzujpgg_Fall%202025%20Newsletter.pdf",
      image: "https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/jq9oghiq_Fall%202025.png"
    }
  ];

  return (
    <div data-testid="newsletter-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/xgd9h5gf_Volunteers%203.jpg"
        alt="Murphy's Giving Market Newsletter"
      />

      {/* Newsletter Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="newsletter-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-12"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Murphy's Giving Market Newsletters
            </h1>
            
            <div className="space-y-6">
              {newsletters.map((newsletter, index) => (
                <motion.div
                  key={newsletter.title}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-6 flex flex-col sm:flex-row items-center gap-4 md:gap-6"
                >
                  {/* Newsletter Preview Image */}
                  <div className="w-full sm:w-32 md:w-40 h-32 md:h-40 flex-shrink-0 overflow-hidden rounded-lg">
                    <img 
                      src={newsletter.image}
                      alt={`${newsletter.title} preview`}
                      data-testid={`newsletter-image-${index}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Newsletter Info */}
                  <div className="flex-1 flex flex-col sm:flex-row items-center sm:justify-between gap-4 w-full">
                    <h3 
                      className="font-semibold text-[#1A1A1A] text-lg md:text-xl text-center sm:text-left"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {newsletter.title}
                    </h3>
                    <a 
                      href={newsletter.url}
                      data-testid={`newsletter-link-${index}`}
                      className="bg-[#C41E3A] hover:bg-[#a31830] text-white px-4 py-2 rounded-full font-medium transition-colors inline-flex items-center gap-2 flex-shrink-0"
                    >
                      View PDF
                      <ChevronRight size={16} />
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default NewsletterPage;
